<mat-card class="p-0">
  <app-single-crawler-list-toolbar
    [count]="list.paginator.totalDocs"
    labelKey="INTEGRATIONS.ANALYZE.TITLE"
    countLabelKeySingular="INTEGRATIONS.ANALYZE.DOCUMENT"
    countLabelKeyPlural="INTEGRATIONS.ANALYZE.DOCUMENTS"
    [showSearch]="false">

      <div filters class="fx-row align-items-center">
        <app-batch-select [integrationId]="integrationId()" class="mr-10"
                          [hideWhenOnlyOneOption]="true"
                          [label]="'INTEGRATIONS.ANALYZE.BATCH' | translate"
                          (change)="onBatchChange($event)"></app-batch-select>
        <app-select [emitOnInit]="false" (change)="onStatusChange($event)" class="mr-10" [disabled]="!selectedBatchId"
                  [label]="'INTEGRATIONS.ANALYZE.STATUS' | translate"
                  [value]="selectedStatus"
                  [options]="statusSelectOptions"></app-select>
        @if (!selection.isEmpty()) {
          <button class="button mr-10" (click)="setSelectionExcluded(true)">
            {{ 'INTEGRATIONS.ANALYZE.EXCLUDE_SELECTION' | translate }} ({{ selection.selected.length }})
          </button>
          <button class="button mr-10" (click)="setSelectionExcluded(false)">
            {{ 'INTEGRATIONS.ANALYZE.INCLUDE_SELECTION' | translate }} ({{ selection.selected.length }})
          </button>
        }
    </div>

    <button class="main-button" primaryAction (click)="analyze()"
            [class.disabled]="analyzing || !selectedBatchId"
            [disabled]="analyzing || !selectedBatchId">
      <span class="fx-row gap-5 align-items-center">
        <mat-icon fontSet="material-icons-outlined">insights</mat-icon>
        {{ analyzeLabel() | translate }}
      </span>
    </button>
  </app-single-crawler-list-toolbar>

  <mat-divider></mat-divider>

  @if (selectedBatch) {
    <div class="fx-row align-items-center justify-content-start p-16 batch-progress">
      <div class="fx-flex-50 border-box pr-8">
        <div class="fx-column">
          <span class="small light">{{ 'BATCH.STATUS' | translate }}</span>
          <app-batch-progress [batch]="selectedBatch" [progress]="progress" [selfPoll]="false"></app-batch-progress>
        </div>
      </div>
      <div class="fx-flex-50 border-box pl-8">
        <div class="fx-column">
          <span class="small light">{{ 'BATCH.SCORE' | translate }}</span>
          <app-batch-score [score]="score" [status]="selectedBatch.status"></app-batch-score>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
  }

  @if (!selectedBatchId) {
    <div class="p-16">
      <span class="text light">{{ 'INTEGRATIONS.ANALYZE.NO_BATCH' | translate }}</span>
    </div>
  } @else {
    <table mat-table [dataSource]="list.paginator.docs" style="z-index: 0;" matSort
           (matSortChange)="onSortChange($event)">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let document">
          @if (isSelectable(document)) {
            <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="toggleSelection(document)"
                          [checked]="selection.isSelected(document._id)"></mat-checkbox>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="small light bold">{{ 'DOCUMENT.NAME' | translate }}</span>
        </th>
        <td mat-cell *matCellDef="let document">
          <div class="fx-row align-items-center justify-content-start">
            <img [src]="documentIcon(document)" [height]="35" class="mr-10"/>
            <span class="text bold clickable" (click)="toDocument(document)">{{ document?.name || '-' }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="class">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="small light bold">{{ 'DOCUMENT.CLASS' | translate }}</span>
        </th>
        <td mat-cell *matCellDef="let document">
          <span class="text">{{
              document.class
                ? ('DOCUMENT_CLASSES.' + document.class.toUpperCase() | translate)
                : '-'
            }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          <span class="small light bold">{{ 'DOCUMENT.STATUS' | translate }}</span>
        </th>
        <td mat-cell *matCellDef="let document">
          <div class="fx-row align-items-center justify-content-start">
            <mat-icon class="mr-5" [class]="documentStatus(document).class" fontSet="material-icons-outlined"
                      [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="documentStatus(document).tooltip">info
            </mat-icon>
            <span class="text">{{ documentStatus(document).label }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let document">
          <button mat-icon-button (click)="toDocument(document)">
            <mat-icon class="main" fontSet="material-icons-outlined">navigate_next</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    @if (!list.loading && list.paginator.totalDocs === 0) {
      <div class="p-16">
        <span class="text light">{{ 'INTEGRATIONS.ANALYZE.NO_DOCUMENTS' | translate }}</span>
      </div>
    }

    <mat-paginator [length]="list.paginator.totalDocs || 0" [pageSize]="list.paginator.limit || 0"
                   [pageIndex]="list.paginator.page ? (list.paginator.page - 1) : 0"
                   [pageSizeOptions]="[10, 25, 50, 100]"
                   (page)="handlePage($event)">
    </mat-paginator>
  }
</mat-card>
